module.exports = __webpack_public_path__ + "img/sword@2x.44323a6a.png";